// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"cdabad77644e29c5","660":"3ed13c27b322abb6"}[chunkId] + ".css";
};